import { X, RefreshCw } from 'lucide-react';

export function RegenerateListDrawer({ isOpen, weekLabel, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/40 z-40 transition-opacity"
        onClick={onCancel}
        aria-hidden="true"
      />

      {/* Drawer */}
      <div 
        className="fixed bottom-0 left-0 right-0 bg-card rounded-t-3xl shadow-2xl z-50 max-w-md mx-auto animate-slide-up"
        role="dialog"
        aria-modal="true"
        aria-labelledby="regenerate-list-title"
      >
        {/* Handle bar */}
        <div className="flex justify-center pt-3 pb-2">
          <div className="w-10 h-1 bg-muted rounded-full" />
        </div>

        {/* Content */}
        <div className="px-6 pb-8 text-foreground">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <h2 id="regenerate-list-title" className="text-xl mb-2">
                Regenerate Shopping List?
              </h2>
              <p className="text-muted-foreground text-sm">
                This will replace your current shopping list for <strong>{weekLabel}</strong> with items automatically generated from your meal plan. Any manual edits or additions will be lost.
              </p>
            </div>
            <button
              onClick={onCancel}
              className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-muted transition-colors flex-shrink-0 ml-2"
              aria-label="Close"
            >
              <X className="w-5 h-5 text-muted-foreground" />
            </button>
          </div>

          {/* Buttons */}
          <div className="flex flex-col gap-3 mt-6">
            <button
              onClick={() => {
                console.log('RegenerateListDrawer button clicked!');
                onConfirm();
              }}
              className="w-full py-3.5 px-4 bg-primary text-primary-foreground rounded-xl hover:bg-primary-hover transition-colors flex items-center justify-center gap-2"
            >
              <RefreshCw className="w-5 h-5" />
              <span>Regenerate List</span>
            </button>
            <button
              onClick={onCancel}
              className="w-full py-3.5 px-4 bg-muted text-foreground rounded-xl hover:bg-[color-mix(in srgb,var(--muted) 80%, var(--foreground) 20%)] transition-colors flex items-center justify-center gap-2"
            >
              <X className="w-5 h-5" />
              <span>Cancel</span>
            </button>
          </div>
        </div>

        {/* Safe area spacing for iOS */}
        <div className="h-8" />
      </div>
    </>
  );
}
